const apiKey = '64c159490b6d7f4b750802422b4ae401';
export default apiKey;